var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { forwardRef } from 'react';
import { Overlay } from './Overlay';
export var ModalCover = forwardRef(function (props, ref) {
    return (jsx(Overlay, __assign({}, props, { ref: ref, sx: {
            position: 'fixed',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            backgroundColor: 'rgba(128,128,128,0.3)',
            padding: 2,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden',
        } })));
});
//# sourceMappingURL=ModalCover.js.map